import React from 'react'
import {
  Facebook,
  InstagramSquare,
  TwitterSolid,
  Youtube,
  Tiktok,
  VocLarge,
  Comment,
  Retweet,
  Reblog,
  Share,
  Play,
  LikeOutlined,
  ThumbUpOutlined,
  Bluesky,
  Show,
  Podcasts
  // @ts-ignore
} from '@netbasequid/core'
import { Domain } from 'enums'
import StreamSymbol from 'enums/StreamSymbol'
import { DomainStrings } from 'enums/Domain'

import { Theme } from '../../../features/ui/types'

interface DomainFactory {
  getIcon: (fontSize: number, mode: Theme) => React.ReactElement
  metrics: ('retweets' | 'replies' | 'shares' | 'comments' | 'likes' | 'reblogs' | 'views')[]
}

export const MetricsMapping: Record<string, DomainFactory> = {
  [Domain.TWITTER]: {
    getIcon(fontSize: number, mode: Theme) {
      return <TwitterSolid fontSize={fontSize} mode={mode} />
    },
    metrics: ['views', 'retweets', 'likes', 'replies']
  },
  [Domain.FACEBOOK]: {
    getIcon(fontSize: number, mode: Theme) {
      return <Facebook fontSize={fontSize} mode={mode} />
    },
    metrics: ['shares', 'likes', 'comments']
  },
  [Domain.INSTAGRAM]: {
    getIcon(fontSize: number, mode: Theme) {
      return <InstagramSquare fontSize={fontSize} mode={mode} />
    },
    metrics: ['likes', 'comments']
  },
  [Domain.YOUTUBE]: {
    getIcon(fontSize: number, mode: Theme) {
      return <Youtube fontSize={fontSize} mode={mode} />
    },
    metrics: ['views', 'likes', 'comments']
  },
  [Domain.TIKTOK]: {
    getIcon(fontSize: number, mode: Theme) {
      return <Tiktok fontSize={fontSize} mode={mode} />
    },
    metrics: ['views', 'comments', 'shares']
  },
  [StreamSymbol.VOC]: {
    getIcon(fontSize: number, mode: Theme) {
      return <VocLarge fontSize={fontSize} mode={mode} />
    },
    metrics: []
  },
  [Domain.BLUESKY]: {
    getIcon(fontSize: number, mode: Theme) {
      return <Bluesky fontSize={fontSize} mode={mode} />
    },
    metrics: []
  },
  [StreamSymbol.PODCAST]: {
    getIcon(fontSize: number, mode: Theme) {
      return <Podcasts fontSize={fontSize} mode={mode} />
    },
    metrics: ['views']
  }
}

export const IconMapping = {
  retweets: {
    label: 'retweet_other',
    getIcon(fontSize: number, mode: Theme, color: string) {
      return <Retweet fontSize={fontSize} mode={mode} color={color} />
    }
  },
  replies: {
    label: 'reply_other',
    getIcon(fontSize: number, mode: Theme, color: string) {
      return <Comment fontSize={fontSize} mode={mode} color={color} />
    }
  },
  shares: {
    label: 'share_other',
    getIcon(fontSize: number, mode: Theme, color: string) {
      return <Share fontSize={fontSize} mode={mode} color={color} />
    }
  },
  comments: {
    label: 'comment_other',
    getIcon(fontSize: number, mode: Theme, color: string) {
      return <Comment fontSize={fontSize} mode={mode} color={color} />
    }
  },
  likes: {
    label: 'like_other',
    getIcon(fontSize: number, mode: Theme, color: string, domain?: DomainStrings) {
      if (domain === Domain.FACEBOOK || domain === Domain.YOUTUBE) {
        return <ThumbUpOutlined fontSize={fontSize} mode={mode} color={color} />
      }
      return <LikeOutlined fontSize={fontSize} mode={mode} color={color} />
    }
  },
  views: {
    label: 'view_other',
    getIcon(fontSize: number, mode: Theme, color: string, domain?: DomainStrings) {
      if (domain === Domain.TWITTER) {
        return <Show fontSize={fontSize} mode={mode} color={color} />
      }
      return <Play fontSize={fontSize} mode={mode} color={color} />
    }
  },
  reblogs: {
    label: 'reblog_other',
    getIcon(fontSize: number, mode: Theme, color: string) {
      return <Reblog fontSize={fontSize} mode={mode} color={color} />
    }
  }
}
